import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface MeasurementValueProps {
	children: ReactNode;
}

export const MeasurementValue = ({ children }: MeasurementValueProps) => {
	if (children !== "-") return <>{children}</>;

	return (
		<Box
			component="span"
			role="img"
			aria-label="No measurement"
			sx={{
				display: "inline-block",
				width: 8,
				height: 2,
				borderRadius: "1px",
				backgroundColor: "currentColor",
				verticalAlign: "middle",
				flexShrink: 0,
			}}
		>
			<Box
				component="span"
				sx={{
					position: "absolute",
					width: "1px",
					height: "1px",
					padding: 0,
					margin: "-1px",
					overflow: "hidden",
					clip: "rect(0, 0, 0, 0)",
					whiteSpace: "nowrap",
					border: 0,
				}}
			>
				-
			</Box>
		</Box>
	);
};
